module.exports = __webpack_public_path__ + "media/images/icons/check-e964a6efc56f4860a246153e052e7927.svg";